import React from "react"

const QpCenterPanel = ({ fillColor, strokeColor }) => (
  <g id="front-panel">
    <path fill={fillColor} d="M206.886 337.054c-26.9-4.4-50.4-8.9-63.6-11.5 2.7 14.7 6.7 41.3 4.6 58.5-3 24.7 10.9 204 12.4 210 1 4.1 7.5 15.2 11.6 22 25.8 9.7 48.801 18 60.801 22.3-6.7-20.1-12.6-104.8-14.5-152.2-1.7-42.3-8.601-119.3-11.301-149.1Z" />
    <path stroke={strokeColor} d="M206.886 337.054c-26.9-4.4-50.4-8.9-63.6-11.5 2.7 14.7 6.7 41.3 4.6 58.5-3 24.7 10.9 204 12.4 210 1 4.1 7.5 15.2 11.6 22 25.8 9.7 48.801 18 60.801 22.3-6.7-20.1-12.6-104.8-14.5-152.2-1.7-42.3-8.601-119.3-11.301-149.1Z" strokeWidth="3" strokeMiterlimit="10"/>
  </g>
)

export default QpCenterPanel
